/** Checkout URL ve adım sabitleri — sunucu bileşenlerinden güvenle import edilebilir (`'use client'` değil). */

export enum CheckoutStepType {
  RECEIVER_INFO = 1,
  BILL_INFO = 2,
  PAYMENT_INFO = 3,
}

export enum ReceiverInfoStep {
  RECEIVER_INFO = 1,
  EXTRA_PRODUCT = 2,
  CARD_MESSAGES = 3,
}

export enum CheckoutPage {
  CHECKOUT_BASE_PAGE = 'satin-al',
  CHECKOUT_RECEIVER_PAGE = 'satin-al-alici-bilgileri',
  CHECKOUT_EXTRA_PAGE = 'satin-al-ekstra-urunler',
  CHECKOUT_PHOTO_PRINT_PAGE = 'satin-al-fotograf-baskisi',
  CHECKOUT_MESSAGE_PAGE = 'satin-al-mesaj-bilgileri',
  CHECKOUT_INVOICE_PAGE = 'satin-al-fatura-bilgileri',
  CHECKOUT_PAYMENT_PAGE = 'satin-al-odeme',
  /** Yeni checkout (AB değil). Tek sayfa, adım `?adim=` ile. */
  CHECKOUT_B_RECEIVER_PAGE = 'satin-al-v2',
}

/** Eski /satin-al sipariş alındı ekranını yeni tasarımdan ayırır. */
export const CHECKOUT_V2_FLOW_KEY = 'hzc_checkout_v2_flow';
/** v2 sepetinin sipariş numaraları. Eski checkout bunlara yazmaz. */
export const CHECKOUT_V2_ORDERS_KEY = 'hzc_checkout_v2_orders';

export interface CheckoutStep {
  type: CheckoutStepType;
  title: string;
  url?: string;
  stepUrls?: { [key: string]: string };
  prevUrl?: string;
}
